import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import TotalStats from '../../components/HorseTabs/TotalStats/TotalStats';
import { useJockeys } from '../../hooks/stable';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import { getJockey } from '../../store/reducers/Stable/jockeys';
import SingleView from '../SingleView/SingleView';
import styles from './JockeyView.module.scss';
var JOCKEY_TAB_KEYS;
(function (JOCKEY_TAB_KEYS) {
    JOCKEY_TAB_KEYS["TOTAL_STATS"] = "TOTAL_STATS";
    JOCKEY_TAB_KEYS["CONFIGURATOR"] = "CONFIGURATOR";
})(JOCKEY_TAB_KEYS || (JOCKEY_TAB_KEYS = {}));
const JockeyView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useAppDispatch();
    const jockey = useAppSelector((state) => state.jockeys.jockey);
    const [data, setData] = useState(null);
    const { jockeys } = useJockeys();
    const buttons = [
        {
            name: t('cancel_sale'),
            disabled: true
        },
        {
            name: t('update_sale'),
            disabled: true
        }
    ];
    //Disabled Configurator Tab per request.
    const jockeyTabs = useMemo(() => [
        {
            label: t('total_stats'),
            value: JOCKEY_TAB_KEYS.TOTAL_STATS
        }
        // {
        //     label: t('configurator'),
        //     value: JOCKEY_TAB_KEYS.CONFIGURATOR
        // }
    ], [t]);
    const [activeTab, setActiveTab] = useState(JOCKEY_TAB_KEYS.TOTAL_STATS);
    const onClick = (value) => {
        setActiveTab(value);
    };
    //Disabled Configurator Tab info per request.
    const renderView = {
        // [JOCKEY_TAB_KEYS.CONFIGURATOR]: <Configurator isJockey={true} horse={horse || null} />,
        [JOCKEY_TAB_KEYS.TOTAL_STATS]: _jsx(TotalStats, {})
    };
    useEffect(() => {
        if (jockeys) {
            setData(jockeys.find((jockey) => jockey.asset.assetName === params.id) || jockeys[0]);
        }
    }, [jockeys, params.id]);
    useEffect(() => {
        if (data) {
            dispatch(getJockey(data.asset));
        }
    }, [data, dispatch]);
    return (_jsx("div", Object.assign({ className: cn(styles.element, 'd-flex') }, { children: _jsxs("div", Object.assign({ className: 'd-flex flex-column' }, { children: [_jsx(SingleView, { activeTab: activeTab, onClick: onClick, navigateTo: () => navigate(-1), buttons: [], tabs: jockeyTabs, className: styles.wrapper, horseClassName: styles.tabs, jockey: jockey || null }), _jsx("div", Object.assign({ className: styles.box }, { children: renderView[activeTab] }))] })) })));
};
export default JockeyView;
